import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Select,
  Checkbox,
  Flex,
  Divider,
  Box,
  ModalCloseButton,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import {
  SupportedLocale,
  getLocaleDisplayName,
} from '../../../../constants/locales';

interface ChangeDefaultLanguageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (language: SupportedLocale) => void;
  availableLocales: SupportedLocale[];
  currentDefault: string;
}

const ChangeDefaultLanguageModal = ({
  isOpen,
  onClose,
  onConfirm,
  availableLocales,
  currentDefault,
}: ChangeDefaultLanguageModalProps) => {
  const [selectedLanguage, setSelectedLanguage] = useState<
    SupportedLocale | ''
  >('');
  const [confirmed, setConfirmed] = useState(false);

  const handleClose = () => {
    setSelectedLanguage('');
    setConfirmed(false);
    onClose();
  };

  const handleConfirm = () => {
    if (selectedLanguage) {
      onConfirm(selectedLanguage as SupportedLocale);
      handleClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent p={3}>
        <ModalCloseButton _hover={{ bg: 'transparent', color: 'grey' }} />
        <Box px={6} pt={6} pb={0}>
          <Flex justify="center" align="center">
            <Text textStyle="heading4">Change default language?</Text>
          </Flex>
        </Box>
        <ModalBody pt={4}>
          <Divider borderColor="lightGrey" mb={4} />
          <Text fontSize="14px" color="grey3" mb={5}>
            Changing the primary language affects how untranslated content
            appears across your pass.
          </Text>
          <Select
            value={selectedLanguage}
            onChange={(e) =>
              setSelectedLanguage(e.target.value as SupportedLocale)
            }
            placeholder="Select language"
            mb={4}
            bg="#EEEEEE"
            border="none"
            borderRadius="md"
            fontSize="14px"
            size="sm"
          >
            {availableLocales
              .filter((locale) => locale !== currentDefault)
              .map((locale) => (
                <option key={locale} value={locale}>
                  {getLocaleDisplayName(locale)}
                </option>
              ))}
          </Select>
          <Checkbox
            variant="primary"
            isChecked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
            mt={2}
            mb={4}
          >
            <Text fontSize="13px">
              I understand this affects all languages and untranslated content
            </Text>
          </Checkbox>
        </ModalBody>
        <ModalFooter gap={3} justifyContent="center">
          <Button variant="text" onClick={handleClose} size="sm" minW="160px">
            Cancel
          </Button>
          <Button
            variant="gradient"
            onClick={handleConfirm}
            isDisabled={!selectedLanguage || !confirmed}
            size="sm"
            minW="160px"
          >
            Confirm change
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ChangeDefaultLanguageModal;
